import { lnResponsePO, lnResponseRB, LnResponseRE } from './../models/lottery.model';
import { Injectable } from '@angular/core';
import { Sorteo, SorteoPath, SorteoTicket, SorteoType, SorteoZodiac } from '../models/sorteo.model';
import { PaymentService } from './payment.service';
import { GameOption, GameTicket, GameType } from '../models/game.model';
import { GeneralService } from './general.service';
import { Logger } from '../logger.service';
import { HttpService } from './http.service';
import { environment } from '@env/environment';
import { TotalGameService } from './total-game.service';
import { LotteryRequest, Draw, ResponseSD, ConfirmResponse } from '@app/@shared/models/lottery.model';

import { WagerPayload } from '../models/wager.model';

import { CredentialsService } from '@app/auth';
import { TrackingService } from './tracking.service';
import { LotenalPaymentService } from './lotenal.payment.service';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { firstValueFrom, take } from 'rxjs';
import { Timestamp } from 'firebase/firestore';

const log = new Logger('sorteo-service');

@Injectable({
  providedIn: 'root',
})
export class SorteoService {
  private path: GameType = 'sorteo';
  private collection = 'drawsClosed';
  private collectionResult = 'resultsLotenal';
  zodiac: SorteoZodiac[] = [];
  refCounter = 1;
  signosZodiaco = [
    { idSigno: 1, nombreSigno: 'ARIES' },
    { idSigno: 2, nombreSigno: 'TAURO' },
    { idSigno: 3, nombreSigno: 'GÉMINIS' },
    { idSigno: 4, nombreSigno: 'CÁNCER' },
    { idSigno: 5, nombreSigno: 'LEO' },
    { idSigno: 6, nombreSigno: 'VIRGO' },
    { idSigno: 7, nombreSigno: 'LIBRA' },
    { idSigno: 8, nombreSigno: 'ESCORPIÓN' },
    { idSigno: 9, nombreSigno: 'SAGITARIO' },
    { idSigno: 10, nombreSigno: 'CAPRICORNIO' },
    { idSigno: 11, nombreSigno: 'ACUARIO' },
    { idSigno: 12, nombreSigno: 'PISCIS' },
  ];
  digitsSign = [
    {
      nombreSorteo: 'superior',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'zodiaco-especial',
      digitosBillete: 4,
      digitosTerminacion: 2,
    },
    {
      nombreSorteo: 'especial',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'gran-especial',
      digitosBillete: 7,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'mayor',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'magno',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'zodiaco',
      digitosBillete: 4,
      digitosTerminacion: 2,
    },
    {
      nombreSorteo: 'gordito',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
  ];
  drawMetaMap: { [key: string]: { shortName: string; logo: string } } = {
    ESPECIAL: { shortName: 'S. Especial', logo: 'sorteoespecial' },
    MAGNO: { shortName: 'S. Magno', logo: 'sorteomagno' },
    MAYOR: { shortName: 'S. Mayor', logo: 'sorteomayor' },
    SUPERIOR: { shortName: 'S. Superior', logo: 'sorteosuperior' },
    ZODIACO: { shortName: 'S. Zodiaco', logo: 'sorteozodiaco' },
    'ZODIACO ESPECIAL': { shortName: 'S. Zodiaco Esp.', logo: 'zodiacoespecial' },
    'GRAN ESPECIAL': { shortName: 'S. G. Especial', logo: 'gransorteoespecial' },
    GORDITO: { shortName: 'S. Navidad', logo: 'sorteonavidad' },
  };
  validGameTypes = [
    'superior',
    'especial',
    'gran-especial',
    'mayor',
    'zodiaco',
    'zodiaco-especial',
    'gordito',
    'magno',
  ];
  sorteoRegex = /^(especial|superior|gran-especial|magno|zodiaco-especial|zodiaco|mayor|gordito)$/;
  sorteoOptionRegex = /^(automatic|favorite|recommended|termination)$/;
  countDoc = 'count';
  private closedDrawsCollection = 'drawsClosed';
  private closedDrawsCollectionN = this.afs.collection('drawsClosed');
  // user!: User;
  constructor(
    private generalS: GeneralService,
    private httpS: HttpService,
    private totalS: TotalGameService,
    private credentialsS: CredentialsService,
    private paymentLS: LotenalPaymentService,
    private trackingS: TrackingService,
    private loadingCtrl: LoadingController,
    private translateS: TranslateService,
    private afs: AngularFirestore
  ) {
    this.generateSignos(this.signosZodiaco as SorteoZodiac[]);
  }

  async counterRefCode(): Promise<number> {
    const ref = this.afs.collection('lotenalCounter').doc(this.countDoc).ref;

    try {
      const newCounter = await this.afs.firestore.runTransaction(async (transaction) => {
        const doc = await transaction.get(ref);
        const data = doc.data() as { counter: number } | undefined;

        let currentCounter = 0;

        if (doc.exists) {
          currentCounter = data?.counter ?? 0;
        }

        const updatedCounter = currentCounter + 1;
        transaction.update(ref, { counter: updatedCounter });

        return updatedCounter;
      });

      log.info(`Nuevo contador: ${newCounter}`);
      return newCounter;
    } catch (error) {
      log.error('Error actualizando el contador:', error);
      throw new Error('No se pudo obtener el contador.');
    }
  }

  getLocalData(): SorteoTicket[] {
    const data = sessionStorage.getItem(this.path);
    // this.user = this.credentialsService.credentials?.user!;
    if (data) {
      const values = JSON.parse(atob(data)) as SorteoTicket[];

      sessionStorage.removeItem(this.path);
      return values;
    }
    return [];
  }

  getPrice(type: SorteoType) {
    log.info(type);
    return type === 'gran-especial' ? 250 : 120;
  }
  getSorteoType(type: SorteoType) {
    return type;
  }
  getPaths(): SorteoPath[] {
    const paths: SorteoPath[] = [
      {
        name: 'Sorteo de Navidad',
        path: 'gordito',
        len: 5,
      },
      {
        name: 'Sorteo Magno',
        path: 'magno',
        len: 5,
      },
      {
        name: 'Sorteo Mayor',
        path: 'mayor',
        len: 5,
      },
      {
        name: 'Sorteo Especial',
        path: 'especial',
        len: 5,
      },
      {
        name: 'Gran Especial',
        path: 'gran-especial',
        len: 7,
      },
      {
        name: 'Sorteo Zodiaco',
        path: 'zodiaco',
        len: 4,
      },
      {
        name: 'Sorteo Zodiaco Especial',
        path: 'zodiaco-especial',
        len: 4,
      },
      {
        name: 'Sorteo Superior',
        path: 'superior',
        len: 5,
      },
    ];

    return paths;
  }
  getZodiacInfo(idSigno: number): { icon: string; idSigno: number; name: string } | null {
    const zodiacSigns = [
      { id: 1, name: 'Aries', icon: 'aries' },
      { id: 2, name: 'Tauro', icon: 'taurus' },
      { id: 3, name: 'Géminis', icon: 'gemini' },
      { id: 4, name: 'Cáncer', icon: 'cancer' },
      { id: 5, name: 'Leo', icon: 'leo' },
      { id: 6, name: 'Virgo', icon: 'virgo' },
      { id: 7, name: 'Libra', icon: 'libra' },
      { id: 8, name: 'Escorpión', icon: 'scorpio' },
      { id: 9, name: 'Sagitario', icon: 'sagittarius' },
      { id: 10, name: 'Capricornio', icon: 'capricorn' },
      { id: 11, name: 'Acuario', icon: 'aquarius' },
      { id: 12, name: 'Piscis', icon: 'pisces' },
    ];

    const signo = zodiacSigns.find((sign) => sign.id === idSigno);
    return signo ? { icon: signo.icon, idSigno: signo.id, name: signo.name } : null;
  }
  saveFavorite(
    ticket: number[],
    type: SorteoType,
    sign?: { name: string; idSigno: number | null; icon?: string }
  ): void {
    const favsString = localStorage.getItem(`${type}Favs`);
    let favs: any[] = favsString ? JSON.parse(favsString) : [];

    const existe = favs.some((f) => Array.isArray(f?.value) && f.value.join(',') === ticket.join(','));

    if (!existe) {
      const favorite = {
        name: type,
        value: [...ticket], // asegura que es array plano
        idSigno: sign?.idSigno ?? 0,
        icon: sign?.icon ?? '',
        available: 0,
        added: 0,
        amount: 0,
        dates: [],
        price: 0,
      };

      favs.push(favorite);
      localStorage.setItem(`${type}Favs`, JSON.stringify(favs));
      this.trackingFavorites(type, ticket);
    }
  }

  async getFavorites(path: string | SorteoPath | SorteoTicket): Promise<any[]> {
    const pathSorteo = typeof path === 'string' ? path : path.path;
    const favsString = localStorage.getItem(`${pathSorteo}Favs`);
    const favs = favsString ? JSON.parse(favsString) : [];

    // Devolver solo objetos válidos
    return favs.filter((f: any) => Array.isArray(f?.value));
  }

  deleteFavorite(ticket: number[], type: SorteoType): void {
    const favsString = localStorage.getItem(`${type}Favs`);
    if (!favsString) return;

    let favs: number[][] = JSON.parse(favsString);

    favs = favs.filter((f) => {
      const isSameValue = Array.isArray(f) && Array.isArray(ticket) && f.join(',') === ticket.join(',');
      if (isSameValue) {
      }
      return !isSameValue;
    });

    localStorage.setItem(`${type}Favs`, JSON.stringify(favs));
  }

  getPremioMayor(type: SorteoType) {
    log.info(type);
    return 81000000;
  }

  setLocalData(data: SorteoTicket[]): void {
    sessionStorage.setItem(this.path, btoa(JSON.stringify(data)));
  }

  async goToPayment(amount: number, tickets: GameTicket[], type?: SorteoType, draw?: Draw) {
    const loading = await this.loadingCtrl.create({ message: this.translateS.instant('loading') });
    await loading.present();

    // Generar el body confirm con los tickets y que cada ticket tenga su drawNumber
    const wager = this.genBodyConfirm(amount, tickets, type);

    await loading.dismiss();
    //console.log('wager: ', tickets);
    return this.paymentLS.goToPayment(amount, this.path, tickets, await wager, draw ?? undefined);
  }

  calculateAmount(tickets: any[]) {
    if (!tickets || !Array.isArray(tickets)) {
      console.error('Invalid tickets array:', tickets);
      return 0; // Retorna un valor por defecto si `tickets` no es válido
    }

    let total = 0;
    tickets.forEach((ticket) => {
      if (ticket && ticket.added && ticket.price) {
        total += ticket.added * ticket.price;
      }
    });
    return total;
  }
  async generateTicketsRandom(
    quantity: number,
    path: SorteoPath,
    price: number,
    dates: Date[],
    v: number[] = [],
    z = '',
    drawType?: number,
    drawNumber?: number
  ) {
    const tickets: SorteoTicket[] = [];
    const reservationResponse = await this.reservRandomNumber(drawType, drawNumber); // Esperar la respuesta del endpoint

    if (!Array.isArray(v)) {
      console.error('v no es un array:', v);
      return tickets;
    }

    for (let i = 0; i < quantity; i++) {
      const value: number[] = v.map((val, ind) => {
        if (val < 0) {
          if (path.path === 'gran-especial' && ind === 0) {
            return this.generalS.generateNumber(0, 2);
          }
          return this.generalS.generateNumber(0, 9);
        }
        return val;
      });

      let zodiac: SorteoZodiac | null = null;

      if (path.path.includes('zodiac')) {
        if (z) {
          zodiac = this.zodiac.find((zod) => zod.name === z) ?? null;
        } else {
          zodiac = this.zodiac[this.generalS.generateNumber(0, this.zodiac.length - 1)];
        }
      }

      tickets.push({
        name: value.join('') + (zodiac ? ' ' + zodiac.name : ''),
        value,
        available: path.path === 'gran-especial' ? 1 : this.generalS.generateNumber(1, 20),
        added: 1,
        icon: zodiac?.icon ?? '',
        dates,
        amount: price,
        price,
        idSigno: zodiac?.idSigno ?? 0,
      });
    }

    const nombresUnicos = new Set<string>();
    const ticketsFiltrados: SorteoTicket[] = [];

    tickets.forEach((persona) => {
      if (!nombresUnicos.has(persona.name)) {
        nombresUnicos.add(persona.name);
        ticketsFiltrados.push(persona);
      }
    });

    return ticketsFiltrados;
  }

  getOptions(): GameOption[] {
    return [
      {
        name: 'Manual',
        path: 'manual',
        icon: {
          name: 'sunny-outline',
        },
      },
      {
        name: 'Terminación',
        path: 'termination',
        icon: {
          name: 'eye-outline',
        },
      },
      {
        name: 'Aleatorio',
        path: 'automatic',
        icon: {
          src: '/assets/icons/dice.svg',
        },
      },
      // {
      //   name: 'Programar',
      //   path: 'schedule',
      //   icon: {
      //     name: 'calendar-clear-outline',
      //   }
      // },
      {
        name: 'Recomendación',
        path: 'recommended',
        icon: {
          name: 'bulb-outline',
        },
      },
      {
        name: 'Favoritos',
        path: 'favorite',
        icon: {
          src: '/assets/icons/luck.svg',
        },
      },
    ];
  }

  generateSignos(signos: SorteoZodiac[]) {
    const iconMap: { [key: string]: string } = {
      ARIES: 'aries',
      TAURO: 'taurus',
      GÉMINIS: 'gemini',
      CÁNCER: 'cancer',
      LEO: 'leo',
      VIRGO: 'virgo',
      LIBRA: 'libra',
      ESCORPIÓN: 'scorpio',
      SAGITARIO: 'sagittarius',
      CAPRICORNIO: 'capricorn',
      ACUARIO: 'aquarius',
      PISCIS: 'pisces',
    };

    this.zodiac = signos.map((signo) => ({
      name: signo.nombreSigno ? signo.nombreSigno.charAt(0) + signo.nombreSigno.slice(1).toLowerCase() : 'Unknown',
      icon: iconMap[signo.nombreSigno?.toUpperCase() ?? ''] || 'default-icon',
      idSigno: signo.idSigno ?? 0,
    }));
  }

  formatDraws(data: ResponseSD, gameType: string): Draw[] {
    const gameTypeUpper = gameType.toUpperCase().replace(/-/g, ' ');
    return data.lnResponseSD.sorteo
      .filter((sorteo) => {
        return sorteo.nombreSorteo.toUpperCase() === gameTypeUpper;
      })
      .map((sorteo) => ({
        idDotacion: sorteo.idDotacion,
        tipoSorteo: sorteo.tipoSorteo,
        numeroSorteo: sorteo.numeroSorteo,
        fechaCelebracion: sorteo.fechaCelebracion,
        nombreSorteo: sorteo.nombreSorteo,
        precioFraccion: sorteo.precioFraccion,
        digitosBillete: sorteo.digitosBillete,
        digitosTerminacion: sorteo.digitosTerminacion,
        codigoDotacion: sorteo.codigoDotacion,
        limiteInfFechaCierre: sorteo.limiteInfFechaCierre,
        limiteSupFechaCierre: sorteo.limiteSupFechaCierre,
        signos: sorteo.signo
          ? sorteo.signo.map((s) => ({
              idSigno: s.idSigno,
              nombreSigno: s.nombreSigno,
            }))
          : undefined,
      }));
  }
  mapDrawsToCustomFormat(draws: Draw[]): any[] {
    return draws.map((draw) => {
      const meta = this.drawMetaMap[draw.nombreSorteo] ?? { shortName: draw.nombreSorteo, logo: 'sorteo' };

      return {
        name: draw.nombreSorteo,
        shortName: meta.shortName,
        logo: meta.logo,
        date: draw.fechaCelebracion,
        tipoSorteo: draw.tipoSorteo,
        drawNumber: draw.numeroSorteo,
      };
    });
  }

  async reservExactNumber(body: any) {
    try {
      const url = `${environment.api.tradicional.reservation}/reservationExactNumber`;
      const response = (await this.httpS.post(url, body)) as any;

      this.setReserv(response, body.lnRequestRB.numeroSorteo);
      return response;
    } catch (error) {
      log.error(error);
      return this.totalS.validateMessageIgt({ errorRetries: true });
    }
  }

  async reservNumberTermination(body: any) {
    try {
      const url = `${environment.api.tradicional.reservation}/reservationTermination`;
      const response = (await this.httpS.post(url, body)) as any;

      this.setReserv(response, body.lnRequestRT.numeroSorteo);
      return response;
    } catch (error) {
      log.error(error);
      return this.totalS.validateMessageIgt({ errorRetries: true });
    }
  }

  async reservRandomNumber(drawType?: number, drawNumber?: number, type?: SorteoType) {
    const sorteoNombre = type?.toLowerCase().replace(/\s/g, '-');
    const match = this.digitsSign.find((d) => d.nombreSorteo === sorteoNombre);
    const digitosBillete = match?.digitosBillete;
    try {
      const url = `${environment.api.tradicional.reservation}/reservationRandom`;

      const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
      const counter = await this.generalS?.counterRefCode();
      const textCounter = `${idPrefix}${counter}`;
      const body = {
        lnRequestRA: {
          requestHeadTerminal: {
            // idTerminal: 1234567890123,
            idTerminal: this.credentialsS.credentials?.id || '',
            ov: environment.userLotenal.ov,
            usuario: environment.userLotenal.user,
            password: environment.userLotenal.password,
            refCode: `random-reservation-${drawNumber}-${textCounter}`,
          },
          tipoSorteo: drawType,
          numeroSorteo: drawNumber,
          cantBilletesReservar: 4,
          codEstado: 9,
        },
      };
      let response = (await this.httpS.post(url, body)) as any;

      this.setReserv(response, drawNumber as number);
      return response;
    } catch (error) {
      //console.log('Error in reservation random: ', error);
    }
  }

  setReserv(response: any, drawNumber: number) {
    //console.log(response);
    if (response.lnResponseRE.responseHeadTerminal) {
      if (
        response.lnResponseRE.responseHeadTerminal.respCodeDescription.includes(
          'RA20A Reservación de billete(s) exitosa'
        )
      ) {
        this.afs.collection('lotenalRelease').add({
          idTransaccion: response.lnResponseRE.idTransaccion,
          drawNumber,
          reservedDate: Timestamp.now(),
          idTerminal: this.credentialsS.credentials?.id || '',
        });
      }
    }

    //comprobar si se reservo bien
    //Si
    //guardarla en collection reservs
    //no
    //
  }

  //Para generar el boleto
  async genBodyConfirm(amount: number, tickets: any[], type?: SorteoType): Promise<WagerPayload[]> {
    try {
      const wagerPayloads = await Promise.all(
        tickets.map(async (ticket) => {
          const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
          const counter = await this.generalS?.counterRefCode();
          const textCounter = `${idPrefix}${counter}`;
          const body: LotteryRequest = {
            lnRequestCR: {
              requestHeadTerminal: {
                idTerminal: this.credentialsS.credentials?.id || '',
                ov: environment.userLotenal.ov,
                usuario: environment.userLotenal.user,
                password: environment.userLotenal.password,
                refCode: `confirm-reservation-${ticket.numeroSorteo}-${textCounter}`,
              },
              idTransaccion: ticket.idTransaccion,
              billetes: ticket.billete.map((b: any) => ({
                numeroBillete: b.numeroBillete,
                cantFracciones: b.cantFracciones,
                signo: b.signo,
                serie: b.serie,
              })),
            },
          };

          if (!type) {
            throw new Error('Tipo de sorteo no definido');
          }

          return {
            product: type,
            gameData: body,
            drawNumber: ticket.numeroSorteo,
          };
        })
      );

      //console.log('wagerPayloads:', wagerPayloads);
      return wagerPayloads;
    } catch (error) {
      console.error(error);
      this.totalS.validateMessageIgt({ errorRetries: true });
      return [];
    }
  }

  async releaseTickets(idTransaccion: number, drawNumber: number) {
    //console.log(`Releasing tickets for transaction ID: ${idTransaccion}, draw number: ${drawNumber}`);
    try {
      if (idTransaccion === 0 || !drawNumber) {
        //console.log(  `No se ejecuta releaseTickets porque idTransaccion es ${idTransaccion} (drawNumber: ${drawNumber})`);
        return;
      }

      const url = `${environment.api.tradicional.reservation}/releaseTickets`;
      const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
      const counter = await this.generalS?.counterRefCode();
      const textCounter = `${idPrefix}${counter}`;
      const body = {
        lnRequestLB: {
          requestHeadTerminal: {
            //  idTerminal: 1234567890123,
            idTerminal: this.credentialsS.credentials?.id || '',
            ov: environment.userLotenal.ov,
            usuario: environment.userLotenal.user,
            password: environment.userLotenal.password,
            refCode: `release-tickets-${drawNumber}-${textCounter}`,
          },
          idTransaccion: idTransaccion,
        },
      };
      let response = (await this.httpS.post(url, body)) as any;
      //console.log('liberando: ', response?.lnResponseLB?.responseHeadTerminal?.respCodeDescription);

      this.removeReserv(idTransaccion.toString());
    } catch (error) {
      //console.log('Error releasing tickets: ', error);
    }
  }

  async removeReserv(idTransaction: string) {
    //console.log(idTransaction);
    try {
      const querySnapshot = await this.afs.firestore
        .collection('lotenalRelease')
        .where('idTransaccion', '==', idTransaction)
        .limit(1)
        .get();

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        const docId = doc.id;

        await this.afs.collection('lotenalRelease').doc(docId).delete();

        console.warn(' document found and delete.');
      } else {
        console.warn('No document found with that transaction ID.');
      }
    } catch (error) {
      console.error('Error fetching or deleting document:', error);
    }
  }

  getSize(type: SorteoType) {
    // | 'especial' 5
    // | 'zodiaco' 5
    // | 'gordito' 6
    // | 'magno' 5
    // | 'mayor' 5
    // | 'superior' 5
    // | 'gran-especial' 7
    // | 'zodiaco-especial' 5

    let size = 0;
    if (type === 'especial') {
      size = 5;
    } else if (type === 'zodiaco' || type == 'zodiaco-especial') {
      size = 5;
    } else if (type === 'gordito') {
      size = 5;
    } else if (type === 'magno' || type === 'mayor' || type === 'superior') {
      size = 5;
    } else if (type === 'gran-especial') {
      size = 7;
    }
    return size;
  }
  //ResponseSD
  addZeroLess(response: ConfirmResponse | ConfirmResponse[], nombreSorteo: SorteoType) {
    const sorteoNombre = nombreSorteo?.toLowerCase().replace(/\s/g, '-');
    const match = this.digitsSign.find((d) => d.nombreSorteo === sorteoNombre);
    const lengthExact = match?.digitosBillete ?? 0;

    if (!lengthExact || lengthExact > 10) return response;

    const processBilletes = (billetes: any[]) => {
      return billetes.map((billete) => {
        let numStr = billete.numeroBillete?.toString() || '';
        if (numStr.length < lengthExact) {
          numStr = numStr.padStart(lengthExact, '0');
        }
        return {
          ...billete,
          numeroBillete: numStr,
        };
      });
    };

    const processResponse = (res: any) => {
      if (res?.lnResponseRE?.billete) {
        res.lnResponseRE.billete = processBilletes(res.lnResponseRE.billete);
      }

      if (res?.lnResponseCR?.billeteConfirmado) {
        res.lnResponseCR.billeteConfirmado = processBilletes(res.lnResponseCR.billeteConfirmado);
      }

      return res;
    };

    if (Array.isArray(response)) {
      return response.map((res) => processResponse(res));
    } else {
      return processResponse(response);
    }
  }

  getDigits(numeroBillete: number | string, drawType: string): number[] {
    if (numeroBillete == null) return [];

    const numeroStr = numeroBillete.toString();

    // Buscamos la configuración del sorteo en digitsSign
    const configSorteo = this.digitsSign.find((sorteo) => sorteo.nombreSorteo === drawType.toLowerCase());

    // Si no existe configuración, devolvemos el número sin cambios
    if (!configSorteo) {
      // console.warn(`No se encontró configuración para el sorteo: ${drawType}`);
      return numeroStr.split('').map(Number);
    }

    const digitosRequeridos = configSorteo.digitosBillete;

    // Agrega los ceros a la izquierda si es necesario
    const numeroFormateado = numeroStr.padStart(digitosRequeridos, '0');

    return numeroFormateado.split('').map(Number);
  }
  //Consulta de premios principales
  async queryMainPrizes(drawType: number, drawNumber: number) {
    const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
    const counter = await this.generalS?.counterRefCode();
    const textCounter = `${idPrefix}${counter}`;
    const body = {
      lnRequestPR: {
        requestHeadOV: {
          ov: environment.userLotenal.ov,
          usuario: environment.userLotenal.user,
          password: environment.userLotenal.password,
          refCode: `prize-main-${drawNumber}-${textCounter}`,
        },
        tipoSorteo: drawType,
        numeroSorteo: drawNumber,
      },
    };
    try {
      const url = `${environment.api.tradicional.prizes}/mainPrizes`;
      const response = (await this.httpS.post(url, body)) as any;

      if (response) {
        if (response.lnResponsePR.ganador) {
          return response;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (error) {
      //console.log('Error getting winners: ', error);
      return null;
    }
  }
  //Consulta de premios vendidos
  async querySoldPrizes(drawType: number, drawNumber: number) {
    const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
    const counter = await this.generalS?.counterRefCode();
    const textCounter = `${idPrefix}${counter}`;
    const body = {
      lnRequestPO: {
        requestHeadOV: {
          ov: environment.userLotenal.ov,
          usuario: environment.userLotenal.user,
          password: environment.userLotenal.password,
          refCode: `query-sold-prizes-${drawNumber}-${textCounter}`,
        },
        tipoSorteo: drawType,
        numeroSorteo: drawNumber,
      },
    };
    try {
      const url = `${environment.api.tradicional.prizes}/querySoldPrizes`;
      const response = (await this.httpS.post(url, body)) as any;

      if (response) {
        if (response.lnResponsePO.foliosPremiados) {
          return response;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (error) {
      //console.log('Error getting winners: ', error);
      return null;
    }
  }

  saveResult(data: any) {
    this.afs.collection(this.collectionResult).add(data);
  }

  trackingFavorites(game: string, combinations: any[]) {
    this.trackingS.trackEvent(
      'favorite_added',
      {
        game_id: game,
        combinations: combinations,
      },
      false,
      false
    );
  }

  getSalesDocId(): string {
    // Obtener la hora local (ajustada a tu zona horaria, ej. 'America/Mexico_City')
    const localTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
    const localHours = localTime.getHours();
    // Formatear fecha en YYYY-MM-DD (usando la fecha local, no UTC)
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    // Si son las 22:00 hrs o más (hora local), usar mañana
    // if (localHours >= 22) {
    //   const tomorrow = new Date(localTime);
    //   tomorrow.setDate(localTime.getDate() + 1);
    //   return formatDate(tomorrow);
    // }

    // Si no, usar la fecha actual local
    return formatDate(localTime);
  }

  async getDrawsClosed() {
    try {
      const data = await firstValueFrom(this.closedDrawsCollectionN.valueChanges());
      return data;
    } catch (error) {
      console.error('Error fetching closed draws:', error);
      return []; // Devuelve un array vacío como valor predeterminado
    }
  }

  async getLastResult(type: string) {
    try {
      const data = await this.afs
        .collection<Sorteo>(this.collectionResult, (ref) =>
          ref
            .where('drawName', '==', type)
            .orderBy('createdAt', 'desc') // ordenar por fecha más reciente
            .limit(1)
        )
        .valueChanges()
        .pipe(take(1)) // obtener solo el primer valor del observable
        .toPromise();

      return data;
    } catch (error) {
      console.error('Error fetching last draws:', error);
      return [];
    }
  }

  async getByDraw(draw: number, type: string) {
    try {
      //console.log(draw, type);
      const data = await this.afs
        .collection<Sorteo>(this.collectionResult, (ref) =>
          ref.where('drawName', '==', type).where('drawNumber', '==', draw).limit(1)
        )
        .valueChanges()
        .pipe(take(1)) // obtener solo el primer valor del observable
        .toPromise();

      return data;
    } catch (error) {
      console.error('Error fetching last draws:', error);
      return [];
    }
  }

  // Método para verificar si hay un sorteo cerrado
  checkCloseDraw(draws: Sorteo[]): { numeroSorteo: number; cerrado: true } | null {
    const now = new Date();

    // Si ya son las 19:45 o más, no mostrar nada
    const limiteHoraFinal = new Date(now);
    limiteHoraFinal.setHours(19, 45, 0, 0); // 19:45:00

    if (now >= limiteHoraFinal) {
      //console.log('Ya pasó la hora límite de las 19:45, no mostrar sorteo cerrado.');
      return null;
    }

    const cerrado = draws.find((draw) => {
      const cierre = new Date((draw.limiteInfFechaCierre as unknown as string).replace(' ', 'T'));
      const cierreMenos15 = new Date(cierre.getTime() - 15 * 60 * 1000);

      // ✅ Considerar cerrado si ya está en los 15 min antes del cierre o ya pasó el cierre
      const isCerrado = now >= cierreMenos15;

      return isCerrado;
    });

    if (cerrado) {
      return {
        numeroSorteo: cerrado.numeroSorteo,
        cerrado: true,
      };
    }

    return null;
  }

  isDrawClosed(fechaCierreStr: string): boolean {
    const now = new Date();

    const fechaCierre = new Date(fechaCierreStr.replace(' ', 'T'));
    const cierreMenos15 = new Date(fechaCierre.getTime() - 2 * 60 * 1000);

    return now >= cierreMenos15;
  }

  getFormattedDateTime(): string {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  normalizeDrawName(name: string): string {
    return name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-');
  }

  validateTicketLotenal(rawResponse: any, drawNumber: number, drawType?: number): boolean {
    log.info('Validating ticket Lotenal:', rawResponse);
    log.info('drawType:', drawType);

    try {
      const lnResponse: LnResponseRE | lnResponseRB =
        rawResponse?.lnResponseRE || rawResponse?.lnResponseRB || rawResponse;

      if (!lnResponse?.billete) {
        log.error('No se encontró billete en la respuesta');
        return false;
      }

      if (drawType === 4) {
        const ticketLengths = lnResponse.billete.map((b) => b.numeroBillete.toString().length);
        const hasInvalidLength = ticketLengths.every((length) => length > 4);

        const isZodiacInvalid = lnResponse.billete.some(
          (b) => b.signo === 0 || b.signo === undefined || b.signo === null
        );

        log.info('Ticket lengths:', ticketLengths);
        log.info('isZodiacInvalid:', isZodiacInvalid);

        const validateLen = ticketLengths.some((length) => length > 4);
        log.info('validateLen:', validateLen);

        const hasSomeInvalidLength = ticketLengths.some((length) => length > 4);

        if (hasSomeInvalidLength || isZodiacInvalid) {
          log.warn('Al menos un bullete está mal.');
          return false; // <- Debe liberar
        }
      }

      return true; // <- Coinciden
    } catch (error) {
      console.error('Error validando ticket Lotenal:', error);
      return false;
    }
  }
}
